import { render, staticRenderFns } from "./salereturns_report.vue?vue&type=template&id=4004005a"
import script from "./salereturns_report.vue?vue&type=script&lang=js"
export * from "./salereturns_report.vue?vue&type=script&lang=js"
import style0 from "./salereturns_report.vue?vue&type=style&index=0&id=4004005a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports